<template>
    <div class="assist">
        <iframe
            v-if="assistBuy == 1"
            id="content"
            :src="assistUrl"
            class="assistStyle"
            width="100%"
            height="100%"
            frameborder="0"
            scrolling="auto"
        />
        <v-dialog
            v-model="value"
            class="expirationbox"
            disabled
            status=""
            :show-close="false"
            kind="alert"
        >
            <span>企点客户通已到期,无法继续使用<br>请联系经销商续费</span>
            <span class="refreshTips">已续费?&nbsp;请<a
                href=""
                @click="getFullCombos"
            >刷新</a>页面</span>
        </v-dialog>
        <div
            v-if="assistBuy == 0"
            class="guidePage"
        >
            <div class="systemContent">
                <div class="systemPage">
                    <h1 class="systemTitle">
                        企点客户通，打通企业微信构建全渠道客户运营系统
                    </h1>
                    <h2 class="systemDetail">
                        同时接待全社交渠道的客户
                    </h2>
                    <h2 class="systemDetail">
                        提供一站式私域流量运营解决方案
                    </h2>
                    <p class="buyBtn">
                        <v-button
                            status="primary"
                            size="large"
                            @click="buyBtnInit"
                        >
                            购买咨询
                        </v-button>
                    </p>
                    <!-- <p class="salePrompt"><i class="icon-time"></i><span>开售后，将第一时间联系您</span></p> -->
                </div>
            </div>
            <div class="PainPoints">
                <h2 class="PainPointsTitle">
                    为您解决企业微信接待 3 大痛点
                </h2>
                <ul class="PainPointsTxt">
                    <li class="PainPointsLift">
                        <p class="PainPointsIssue">
                            <i class="icon-tong" />
                            <span class="IssueLeftTxt">客户渠道分散，统一管理难</span>
                        </p>
                    </li>
                    <li class="PainPointsRight">
                        <p class="PainPointsIssue">
                            <i class="icon icon-help" />
                            <span class="IssueLeftTxt">全渠道客户库，同步管理所有客户</span>
                        </p>
                    </li>
                </ul>
                <ul class="PainPointsTxt">
                    <li class="PainPointsLift">
                        <p class="PainPointsIssue">
                            <i class="icon-tong" />
                            <span class="IssueLeftTxt">营销拓客能力不足</span>
                        </p>
                    </li>
                    <li class="PainPointsRight">
                        <p class="PainPointsIssue">
                            <i class="icon icon-tool" />
                            <span class="IssueLeftTxt">精细化营销工具，助力高效获客转化</span>
                        </p>
                    </li>
                </ul>
                <ul class="PainPointsTxt">
                    <li class="PainPointsLift">
                        <p class="PainPointsIssue">
                            <i class="icon-tong" />
                            <span class="IssueLeftTxt">员工服务质量监管难</span>
                        </p>
                    </li>
                    <li class="PainPointsRight">
                        <p class="PainPointsIssue">
                            <i class="icon icon-set" />
                            <span class="IssueLeftTxt">全程留痕可追溯，促进服务质量提升</span>
                        </p>
                    </li>
                </ul>
            </div>
            <div class="refineBanner">
                <!-- 设计稿更新后删除线条背景  -->
                <!-- <div class="refineBanImg"></div> -->
                <div class="refineContent">
                    <div class="fl item-left">
                        <h2 class="refineTitle">
                            接待企微客户，扩充营销生态圈
                        </h2>
                        <h3 class="refineDetail">
                            连接企业微信，打通微信通路接待
                        </h3>
                        <h3 class="refineDetail">
                            触达更多客户商机，打造全渠道营销生态
                        </h3>
                        <div class="itemImg Img-weChat" />
                    </div>
                    <div class="fl item-right">
                        <h2 class="refineTitle">
                            营销裂变工具，沉淀私域流量
                        </h2>
                        <h3 class="refineDetail">
                            一键生成素材、消息群发、渠道活码、自动打标签
                        </h3>
                        <h3 class="refineDetail">
                            帮助沉淀微信私域流量，助力客户增长
                        </h3>
                        <div class="itemImg Img-marketing" />
                    </div>
                    <div class="fl item-left">
                        <h2 class="refineTitle">
                            精细化社群运营，助力促活转化
                        </h2>
                        <h3 class="refineDetail">
                            群活码、定时群发、入群欢迎语、群数据分析
                        </h3>
                        <h3 class="refineDetail">
                            精准化运营投放，定向转化目标客户
                        </h3>
                        <div class="itemImg Img-community" />
                    </div>
                    <div class="fl item-right">
                        <h2 class="refineTitle">
                            全渠道客户库，一体化跟进管理
                        </h2>
                        <h3 class="refineDetail">
                            企微联系人也能加入企点客户库，统一分配流转更方便
                        </h3>
                        <h3 class="refineDetail">
                            客户资料多端自动同步，支持分渠道管理客户
                        </h3>
                        <div class="itemImg Img-employee" />
                    </div>
                    <div class="fl item-left">
                        <h2 class="refineTitle">
                            侧边栏客户画像，提升服务效率
                        </h2>
                        <h3 class="refineDetail">
                            接待企微联系人时，也可使用客户资料、快捷回复、
                        </h3>
                        <h3 class="refineDetail">
                            客户轨迹等侧边栏工具，大幅提升接待效率
                        </h3>
                        <div class="itemImg Img-customer" />
                    </div>
                    <div class="fl item-right">
                        <h2 class="refineTitle">
                            留存聊天记录，监督服务质量
                        </h2>
                        <h3 class="refineDetail">
                            合规留存员工与企微联系人的聊天记录
                        </h3>
                        <h3 class="refineDetail">
                            管理者还可查看会话时长、会话质量等质检指标
                        </h3>
                        <div class="itemImg Img-chatRecord" />
                    </div>
                </div>
                <!-- <div class="refineBanImg"></div>
                <div class="refineBanRightImg"></div> -->
            </div>
            <div class="purchaseContent">
                <div class="purchasePage">
                    <h1 class="purchaseTitle">
                        购买『企点客户通』，即可同时接待微信客户
                    </h1>
                    <p
                        class="purchaseBtn"
                        @click="buyBtnInit"
                    >
                        <span>购买咨询</span>
                    </p>
                    <!-- <p class="saleTxt">开售后，将第一时间联系您</p> -->
                </div>
            </div>
            <div class="guideFoot">
                <div class="footContent">
                    <h1 class="footTitle">
                        正在使用企业微信？一键无缝对接，资产自动同步
                    </h1>
                    <h2 class="footDetail">
                        购买『企点客户通』并绑定企业微信后，以下资产将自动同步到企点
                    </h2>
                </div>
                <ul class="assetsContent">
                    <li class="assetsTxt">
                        <div class="assetsTxt-Img Img-customer" />
                        <div class="assetsTitle">
                            客户
                        </div>
                        <div class="assetsDetails">
                            <h3>已添加好友的客户将自动加入客户库</h3>
                            <h3>客户画像、标签等资料将自动同步到企点</h3>
                        </div>
                    </li>
                    <li class="assetsTxt">
                        <div class="assetsTxt-Img Img-group" />
                        <div class="assetsTitle">
                            客户群
                        </div>
                        <div class="assetsDetails">
                            <h3>在企点即可管理企业微信客户群</h3>
                            <h3>可查看群内客户进群时间和方式</h3>
                        </div>
                    </li>
                    <dl class="assetsTxt">
                        <div class="assetsTxt-Img Img-staff" />
                        <div class="assetsTitle">
                            员工
                        </div>
                        <div class="assetsDetails">
                            <h3>企业微信员工也可在企点组织架构中查看</h3>
                            <h3>绑定账号后，即可同时接待微信和QQ客户</h3>
                        </div>
                    </dl>
                    <dl class="assetsTxt">
                        <div class="assetsTxt-Img Img-business" />
                        <div class="assetsTitle">
                            业务数据
                        </div>
                        <div class="assetsDetails">
                            <h3>企业微信客户标签将自动同步到企点</h3>
                            <h3>所有聊天和应用数据都不丢失</h3>
                        </div>
                    </dl>
                </ul>
            </div>
            <v-panel
                v-if="channel == 0"
                v-model="open"
                class="buyPanel"
                width="560"
                max-height="590"
                :mask-closable="false"
            >
                <div v-if="open">
                    <div class="buyPanel-Img" />
                    <!-- <h2 class="buyPanelTxt">请留下联系方式，开售后将第一时间联系您</h2> -->
                    <h2 class="buyPanelTxt">
                        请留下联系方式，销售顾问稍后给您回电
                    </h2>
                    <v-form
                        ref="buyFormContent"
                        class="buyForm"
                        @submit="buyFormSubmit"
                    >
                        <v-form-item
                            name="userName"
                            :error="userNameStr"
                            error-placement="top-right"
                            class="userNameInput"
                            :rules="userNameRules"
                        >
                            <v-input
                                v-model="userNameInit"
                                name="interest"
                                kind="simple"
                                :limit="15"
                                required
                                autofocus
                                placeholder="联系人姓名"
                            />
                        </v-form-item>
                        <div class="verification-container">
                            <v-form-item
                                name="mobile"
                                :error="mobileStr"
                                error-placement="top-right"
                                :rules="mobileRules"
                            >
                                <v-input
                                    v-model="mobileInit"
                                    kind="simple"
                                    placeholder="手机号"
                                    limit="11"
                                    required
                                    length-calculator="default"
                                    type="number"
                                />
                            </v-form-item>
                            <v-button
                                id="TencentCaptcha"
                                data-appid="2090293405"
                                data-cbfn="callback"
                                type="button"
                                class="verification-alert"
                                :disabled="isGetCodeDisabled"
                                @click="getCode"
                            >
                                {{ alertString }}
                            </v-button>
                        </div>
                        <v-form-item
                            name="verifyCode"
                            :error="verifyCodeStr"
                            error-placement="top-right"
                            class="userNameInput"
                            :rules="verifyCodeRules"
                        >
                            <v-input
                                v-model="verifyCodeInit"
                                name="interest"
                                kind="simple"
                                :limit="4"
                                placeholder="验证码"
                            />
                        </v-form-item>
                        <!-- <div class="demo-textarea-left">
                        <v-form-item name="textarea">
                            <v-textarea
                                v-model="textareaInit"
                                placeholder="接待企微客户时，您还想使用什么能力？"
                            ></v-textarea>
                        </v-form-item>
                    </div> -->
                        <v-form-item>
                            <p class="buyPanelBtn">
                                <v-button
                                    status="primary"
                                    size="large"
                                    type="submit"
                                >
                                    确定
                                </v-button>
                            </p>
                        </v-form-item>
                    </v-form>
                </div>
            </v-panel>
            <!-- 后与产品gloriafan(范文琦)沟通，取消经销商信息并且修改提示文案-->
            <!-- <v-dialog v-model="open" v-if="channel == 1" title="请联系经销商购买" kind="alert">
                <div class="dialogTxt">经销商：{{ agencyName }}&nbsp;{{ agencyTelephone }}</div>
            </v-dialog> -->
            <!-- <v-dialog v-model="open" v-if="channel == 1" title="请联系您的经销商或官网客服购买" kind="alert"> -->
            <v-dialog
                v-if="channel == 1"
                v-model="open"
                title="请联系您的经销商购买"
                kind="alert"
            >
                <!-- <div class="dialogTxt">经销商：{{ agencyName }}&nbsp;{{ agencyTelephone }}</div> -->
            </v-dialog>
        </div>
    </div>
</template>
<script>
import catchErr from '@/utils/catchError';

export default {
  data() {
    return {
      value: false,
      assistBuy: this.assistBuy,
      open: false,
      channel: this.channel,
      agencyName: this.agencyName,
      agencyTelephone: this.agencyTelephone,
      userNameInit: '',
      mobileInit: '',
      verifyCodeInit: '',
      textareaInit: '',
      verifyCodeStr: '',
      userNameStr: '',
      mobileStr: '',
      alertString: '发送验证码',
      isGetCodeDisabled: false,
      userNameRules: [{ required: true, message: '不能为空' }],
      mobileRules: [
        { required: true, message: '不能为空' },
        {
          validate: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
          message: '请输入正确的电话号码',
        },
      ],
      verifyCodeRules: [{ required: true, message: '不能为空' }],
    };
  },
  created() {
    this.init();
  },
  mounted() {
    // if (this.assistBuy === 1) {
    //     this.getFullCombos();
    // } else if (this.assistBuy === 0) {
    //     this.value = false;
    // }
  },
  methods: {
    init() {
      const pageData = window.pageData.data || {};
      this.assistUrl = pageData.url;
      this.assistBuy = pageData.buy;
      this.channel = pageData.agency && pageData.agency.channel;
      this.agencyName = pageData.agency.agencyName;
      this.agencyTelephone = pageData.agency && pageData.agency.agencyTelephone;
    },
    buyBtnInit(e) {
      e.preventDefault();
      this.open = true;
    },
    getCode() {
      const mobileRule = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      const mobile = mobileRule.test(this.mobileInit);
      if (mobile === true) {
        const phoneInit = this.mobileInit;
        // console.log(FVerifyPhone);
        const captcha = new window.TencentCaptcha('2090293405', (res) => {
          // console.log('验证码回调');
          // console.log(res);
          // console.log(res.ticket);
          // console.log(res.randstr);
          const that = this;
          that.tackBtn();
          that.$ajax
            .post('/mng/account/embed/SendSmS', {
              FTypeId: 25,
              FVerifyPhone: phoneInit,
              FTicket: res.ticket,
              FRandstr: res.randstr,
            })
            .then((data) => {
              if (data.r === 0) {
                that.$message.success(data.msg || '');
              } else {
                that.$message.error(data.msg || '');
              }
            });
        });
        captcha.show();
      }
    },
    tackBtn() {
      // 验证码倒数60秒
      let time = 60;
      const that = this;
      const timer = setInterval(
        (function tick() {
          if (time === 0 && timer) {
            clearInterval(timer);
            that.alertString = '发送验证码';
            that.isGetCodeDisabled = false;
          } else {
            that.isGetCodeDisabled = true;
            that.alertString = `${time}秒后重试`;
            time -= 1;
          }
          return tick;
        }()),
        1000,
      );
    },
    buyFormSubmit(e) {
      e.preventDefault();
      const params = this.$refs.buyFormContent.params();
      this.$ajax
        .post('/mng/account/embed/SignUp', {
          FTypeId: 25,
          FVerifyCode: params.verifyCode,
          FData: JSON.stringify({
            FTel: params.mobile,
            FName: params.userName,
          }),
        })
        .then((res) => {
          if (res.r === 0) {
            this.$message.success(res.msg || '');
            this.open = false;
          } else if (res.r === 10020) {
            this.verifyCodeStr = '验证码错误';
            this.$message.error(res.message || '');
            this.open = true;
          } else {
            this.$message.error(res.message || '');
            this.open = true;
          }
        })
        .catch((error) => {
          this.open = true;
          // 处理 “腾讯云网关拦掉xss,sql注入攻击” ，业务没有准确err 信息的情况
          if (error.message.indexOf('501') > -1) {
            this.$message.error('请输入正确的联系人姓名和手机号');
          } else {
            this.$message.error(catchErr.catchErr(error));
          }
        });
    },
    getFullCombos() {
      this.$ajax.gatewayPost('/v1/combo/getFullCombos', {
        use_cache: true,
        with_expired: true,
      })
        .then((res) => {
          if (res.code === 0) {
            // res是返回数据 只有code为0才能触发这里的逻辑
            const combos = res.data.combos || [];
            for (const i in combos) {
              if (combos[i].id === 10051) {
                const customerData = combos[i];
                if (customerData.expired === true) {
                  this.value = true;
                } else {
                  this.value = false;
                }
              } else {
                this.value = false;
              }
            }
            // console.log(res);
          }
        })
        .catch((err) => {
          // / err.message是提示的错误信息 code不为0或者接口状态非200都会触发这里的逻辑
          const { message } = err || {};
          this.$message.error(message || '请求错误');
        });
    },
  },
};
</script>
<style lang="less">
@import './styles/app.less';
</style>
